<script>
    import IconQuestionCircle from "./icons/IconQuestionCircle.svelte";
    import BootstrapCard from "./BootstrapCard.svelte";

    function openChatModal() {
        // Select the visible chat button
        const chatButtons = document.querySelectorAll('button.btn.chat');
        let visibleChatButton = null;

        chatButtons.forEach(function(chatButton) {
            const style = window.getComputedStyle(chatButton);
            if (style.display !== 'none' && style.visibility !== 'hidden') {
                visibleChatButton = chatButton;
                return;
            }
        });

        if (visibleChatButton) {
            // Dispatch a click event on the chat button
            visibleChatButton.dispatchEvent(new MouseEvent('click'));
        }
    }

    window.addEventListener('resize', function() {
        // Re-select the chat button when the window is resized
        const chatButtons = document.querySelectorAll('button.btn.chat');
        let visibleChatButton = null;

        chatButtons.forEach(function(chatButton) {
            const style = window.getComputedStyle(chatButton);
            if (style.display !== 'none' && style.visibility !== 'hidden') {
                visibleChatButton = chatButton;
                return;
            }
        });

        if (visibleChatButton) {
            // Update the click event listener to trigger the modal
            visibleChatButton.removeEventListener('click', openChatModal);
            visibleChatButton.addEventListener('click', function() {
                // Your chat modal code here...
            });
        }
    });

    /** add scroll to top on links below **/
</script>


<BootstrapCard classes="cta card w-100 mb-4 bg-ltblue">
    <span slot="content">
        <span class="d-flex justify-content-center align-items-center">
            <div class="d-none d-lg-block col-md-2 align-content-center justify">
                <IconQuestionCircle width="3rem" height="3rem" padding="2rem" fill="#005e70"/>
            </div>
            <div class="col-12 col-lg-10">
                <h3>Not finding what you need?</h3>
                <ul class="mb-4">
                    <li>Select your class in the <a href="/by-class">By Class tab</a> at the top of the page to find recommended databases.</li>
                    <li>Click the <a href="/all-databases">All Databases tab</a> above for the complete list of databases.</li>
                </ul>
                <p class="lead">Need more help? <button class="p-0 m-0" on:click={openChatModal}>Click here to Chat with a Librarian</button>.</p>

            </div>
        </span>
    </span>
</BootstrapCard>

<style>
    button {
        border: 0;
        background: transparent;
        color: var(--color-primary);
        text-decoration: none;
    }

    button:hover {
        text-decoration: underline;
    }
</style>